module.exports = __webpack_public_path__ + "img/diagnosis-dialog-bg-4.95012914.png";